import { onBeforeMount, onMounted, ref, watch } from 'vue'
import { getCurrentFeatureSlug } from '$/utils/index.js'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '$/stores/index.js'
import { useSessionStore } from '$/stores/session.js'
import { useSubscriptionStore } from '$/stores/subscription.ts'
import { useFeatureStore } from '$/stores/feature.ts'
import LayoutDefault from '&/LayoutDefault.vue'
import LayoutInteractive from '&/LayoutInteractive.vue'
import FeatureInitSection from '&/FeatureInitSection.vue'
import AppNotice from '&/AppNotice.vue'
import { closeDropdown } from '$/utils/index.js'

export function useFeatureSetup() {
  const route = useRoute()
  const router = useRouter()
  const store = useStore()
  const sessionStore = useSessionStore()
  const featureStore = useFeatureStore()
  const subscriptionStore = useSubscriptionStore()
  const ready = ref(false)
  const slug = getCurrentFeatureSlug()

  onBeforeMount(() => {
    // Clear data when navigating away
    featureStore.previewStatuses = []
    featureStore.results = []
    featureStore.imageData = []
    if (!route.query.keep_uploaded) {
      featureStore.images = []
    }
  })

  onMounted(() => {
    closeDropdown('dropdownTool', 'dropdownToolLink')

    // Auto-select full size if paid user
    if (subscriptionStore.isPaidUser) {
      featureStore.taskOptions.size = 'full'
    }

    featureStore.featureLimit =
      featureStore.featureLimits.find((i) => {
        return i.feature_slug === slug && i.plan_slug === subscriptionStore.subscription.plan_slug
      }) ||
      featureStore.featureLimits.find((i) => {
        return i.feature_slug === 'default' && i.plan_slug === subscriptionStore.subscription.plan_slug
      })
    featureStore.fetchFeature(getCurrentFeatureSlug()).finally(() => {
      ready.value = true
      if (import.meta.env.DEV) console.table(featureStore.featureLimit)
    })
  })

  function watchRestrictedOption(slug, optionKey, optionValue, restrictValue) {
    watch(
      () => featureStore.options[slug]?.[optionKey],
      (newVal, oldVal) => {
        if (newVal === optionValue && featureStore.featureLimit.restrict_options.includes(restrictValue)) {
          showModal()
          setTimeout(() => {
            featureStore.options[slug][optionKey] = oldVal
          }, 500)
        }
      },
      { immediate: true },
    )
  }

  function watchTaskOptions() {
    watch(
      () => featureStore.taskOptions.size,
      (newVal, oldVal) => {
        if (newVal === 'full' && !subscriptionStore.isPaidUser) {
          showModal()
          setTimeout(() => {
            featureStore.taskOptions.size = oldVal
          }, 500)
        }
      },
      { immediate: true },
    )
  }

  function showModal() {
    if (sessionStore.user) {
      subscriptionStore.subscriptionModal.show()
    } else {
      sessionStore.authModal.show()
    }
  }

  return {
    route,
    router,
    store,
    sessionStore,
    subscriptionStore,
    featureStore,
    ready,
    slug,
    watchRestrictedOption,
    watchTaskOptions,
    LayoutDefault,
    LayoutInteractive,
    FeatureInitSection,
    AppNotice,
  }
}
